import { Request } from '@/classes/Request'
import { Util } from '@/modules/util'

export interface AddFormTokenResponse {
  token: string
  formsEngineUrl: string
}

export const addFormToken = async (payload: Object): Promise<AddFormTokenResponse> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/form/fetch_form_token`, { payload: Util.Obj.keysToSnake(payload) })
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data) as AddFormTokenResponse)
      })
      .catch(err => {
        reject('Failed to get form token: ' + err)
      })
  })
}
